<template>
  <div :class="[$style.root, $style.overlay]">
    <Spinner color="inverse" size="large">
      {{ content }}
      <slot />
    </Spinner>
  </div>
</template>

<script lang="ts">
import { Spinner } from '@raksul/kamii-vue'

export default {
  components: { Spinner },

  props: {
    content: {
      type: String,
      default: 'しばらくお待ち下さい'
    }
  }
}
</script>

<style lang="postcss" module>
.root {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.overlay {
  position: fixed;
  inset: 0;
  z-index: var(--z-index-loader-overlay);
  background-color: rgb(var(--color-k100-rgb), 0.4);
}
</style>
